import { useEffect, useState } from "react";
import NavigationBar from "./NavigationBar";
import {apiFetch} from "../lib/api";
import {openCameraVideoWS, openWS} from "../lib/ws";


const ActiveCameras = () => {
  const [activeCameras, setActiveCameras] = useState<string[]>([]);

  useEffect(() => {
    const fetchCameras = async () => {
      try {
        const res = await apiFetch("/cameras/active");
        const data = await res.json();
        setActiveCameras(data);
      } catch (err) {
        console.error("Failed to fetch camera list:", err);
      }
    };

    fetchCameras();

    const ws = openWS("/active_cameras");
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.cameras) setActiveCameras(data.cameras);
      } catch (err) {
        console.error("Failed to parse camera WebSocket data:", err);
      }
    };

    ws.onclose = () => console.warn("Camera WebSocket closed");

    return () => ws.close();
  }, []);

  return (
    <div className="bg-black min-h-screen text-white">
      <NavigationBar />
      <div className="p-6">
        <h2 className="text-xl font-bold mb-4">Active Cameras</h2>
        {activeCameras.length === 0 ? (
          <p className="text-gray-400">No cameras online.</p>
        ) : (
          <ul className="space-y-2">
            {activeCameras.map((cam, index) => (
              <li
                key={index}
                className="bg-gray-700 p-3 rounded shadow hover:bg-gray-600 transition-colors"
              >
                {cam}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ActiveCameras;
